export const isNumber = (n) => typeof n !== "string"
    && !isNaN(parseFloat(n))
    && isFinite(n);
